<template>
  <v-select
    v-model="item"
    dir="rtl"
    :multiple="multiple"
    label="Title"
    :reduce="x => x.Id"
    :options="items"
    :loading="loading"
    :selectable="x => unselectable.includes(x.Id) === false || x === val"
    :clearable="clearable"
    @open="onOpen"
    @option:selected="$emit('selected',$event)"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'Brand',
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: null,
      val: this.value,
      loading: false,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  computed: {
    ...mapState('zirehState', { items: state => state.brandSelect }),
    ...mapState('zirehState', { flag: state => state.brandSelectFlag }),
    item: {
      get() {
        if (this.value && (this.value.length || this.multiple === false)) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  methods: {
    get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setBrandSelectFlag', true)
        this.loading = true
        this.$http.post(
          this.$api.brand.getall, {},
        )
          .then(res => {
            this.$store.commit('zirehState/setBrandSelect', res.data)
            this.loading = false
          })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
